
















import { Component, Vue, Watch } from 'vue-property-decorator';
import { MessageController } from '@/services/request.service';
import SentMsgDetail from '@/components/SentMsgDetail.vue';
import ReceiveMsgDetail from '@/components/ReceiveMsgDetail.vue';
import { saveAs } from 'file-saver';
import moment from 'moment';

@Component({
  components: {
    SentMsgDetail,
    ReceiveMsgDetail,
  },
})
export default class MessageDetail extends Vue {
  public list: Array<any> = [];
  public moment = moment;

  public created(): void {
    this.getDetail();
  }

  public get locale(): string {
    return this.$i18n.locale;
  }

  public getDetail(): void {
    const id = this.$route.query.id;
    if (id) {
      MessageController.getSendMessageDetail(Number(id))
        .then(res => {
          this.list = res.data;
        })
        .catch(() => {});
    }
  }
}
